import GameObject from '../GameObject/GameObject';
import * as PIXI from 'pixi.js';

export type ComponentAttachParams<T> = T extends Component & { attach(gameObject: infer GO, params: infer Params): void } ? Params : never;
export type ComponentUpdateParams<T> = T extends Component & { update(params: infer Params): void } ? Params : never;

export default class Component<
    U extends PIXI.Container = PIXI.Container,
    T extends GameObject<U> = GameObject<U>,
    // FIXME: Should extend from a base interface instead of any
    AttachParams extends any = any
> {
    public gameObject: T;
    public container: U;

    [key: string]: any;

    public attach(gameObject: T, params: any): void {
        this.gameObject = gameObject;
        this.container = gameObject.container;

        this.update(params);

        this.onAttach(this.gameObject, this.container, params);
    }

    public detach(): void {
        this.onDetach(this.gameObject, this.container);
        this.gameObject = undefined;
        this.container = undefined;
    }

    public update(params?: any) {
        if (params) {
            for (let key in params) {
                if (key in this) {
                    this[key] =
                        params[key] !== undefined ? params[key] : this[key];
                }
            }
        }
        this.onUpdate(this.gameObject, this.container, params);
        
        return this;
    }

    protected onAttach(gameObject: T, container: U, params: any): void {}

    protected onUpdate(gameObject: T, container: U, params: any): void {}

    protected onDetach(gameObject: T, container: U): void {}

}
